import React from 'react'
import './circularProgressIndicator.scss'

/**
 * @function CircularProgressIndicator
 */
const CircularProgressIndicator = ({ size }) => {
  return (
    <div className="circular-progress" style={{ width: size, height: size }}>
      <div className="inner" style={{ width: size - 4, height: size - 4 }}></div>
      <div className="outer"></div>
    </div>
  )
}

export default CircularProgressIndicator
